import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./HomePage/home";
import Login from "./LoginPage/Login";
import Import from "./ImportPage/Import";
import Export from "./ExportPage/Export";
import Help from "./HelpPage/Help";
import Product from "./ProductPage/Product";
import Agent from "./AgentPage/Agent";
import Customer from "./CustomerPage/Customer";

import RoutePage from "./RoutePage/Route";
import MapContainer from './RoutePage/Maps';

import NotFound from "./NotFound/NotFound";

//Promotion
import Promotion from "./PromotionPage/Promotion";

//Store
import Store from "./StorePage/Store";
import StoreRouteMapping from "./StorePage/StoreRoute";
import StoreDeliverySchedule from './StorePage/StoreDeliverySchedule';
import ViewStoreDelivery from './StorePage/ViewStoreDelivery';
import StoreDeliveryPendingApproval from './StorePage/StoreDeliveryPendingApproval';
import StoreSummary from './StorePage/StoreSummary';
import PaymentTransactions from './StorePage/PaymentTransactions';
import Invoice from './StorePage/Invoice';
import Indent from './StorePage/Indent';
import InactiveStoresByDeliveryPattern from './StorePage/InactiveStoresByDeliveryPattern';
import StoreLedgerReport from './StorePage/StoreLedgerReport';
import StoreEarning from './StorePage/StoreEarning';

//Reports 
import Summary from './Reports/SummaryPage/Summary';
import Schedule from './Reports/SchedulePage/Schedule';
import PendingBottle from './Reports/PendingBottlePage/PendingBottle';
import SalesStats from './Reports/SalesStatsPage/SalesStats';
import CustomerTransactions from './Reports/CustomerTransactionsPage/CustomerTransactions';
import SalesReport from './Reports/SalesReportPage/SalesReport';
import AgentReport from './Reports/AgentReportPage/AgentReport';
import StoresB2W from "./Reports/StoresB2WPage/StoresB2W";
import StoresReport from "./Reports/StoresReportPage/StoresReport";
import ReturnsReport from "./Reports/ReturnsReportPage/ReturnsReport";
import UnAttendedStores from "./Reports/UnAttendedStores/UnAttendedStores";
import StoreShelfStats from "./Reports/StoreShelfStats/StoreShelfStats";

// Components
import AppliedRoute from "./components/AppliedRoute";

//Tools
import Notification from './Tools/Notification';
import ManageReason from "./Tools/ManageReasons";
import OrganisationInformation from "./Tools/OrganisationInformation"
import ActivityTracking from "./Tools/ActivityTracking"
import Jobs from "./Tools/Jobs"

// Inventory
import ManageInventoryMaster from "./Inventory/ManageInventoryMaster";
import InventoryTransactions from "./Inventory/InventoryTransactions";
import InventoryStockSummary from "./Inventory/InventoryStockSummary";
import DailyInventoryReport from "./Inventory/DailyInventoryReport";
import StoresWithNoOrders from "./StorePage/StoresWithNoOrders";
import StoresWithNoRecentOrders from "./StorePage/StoresWithNoRecentOrders";
import StoreDeliveryStatus from "./StorePage/StoreDeliveryStatus";
import OpeningStockReport from "./Inventory/OpeningStockReport";
import VerifyPhysicalStockReport from "./Inventory/VerifyPhysicalStockReport";
import InventoryReport from "./Inventory/InventoryReport";
import AgentGraphReport from "./Reports/AgentGraphReportPage/AgentGraphReport";
import DeliverySequencePlanner from "./StorePage/DeliverySequencePlanner";
import StateWiseDeliveryReport from "./Reports/StateWiseReportPage/StateWiseDeliveryReport";
import ViewCustomerSchedule from "./CustomerPage/ViewCustomerSchedule";
import CustomerDeliverySchedule from "./CustomerPage/CustomerDeliverySchedule";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path={`/`} exact component={Home} props={childProps} />
    <AppliedRoute path={`/login`} exact component={Login} props={childProps} />
    <AppliedRoute path={`/import`} exact component={Import} props={childProps} />
    <AppliedRoute path={`/export`} exact component={Export} props={childProps} />
    <AppliedRoute path={`/help`} exact component={Help} props={childProps} />
    <AppliedRoute path={`/product`} exact component={Product} props={childProps} />
    <AppliedRoute path={`/agent`} exact component={Agent} props={childProps} />

    {/* Route */}
    <AppliedRoute path={`/route`} exact component={RoutePage} props={childProps} />
    <AppliedRoute path={`/route/routemap`} exact component={MapContainer} props={childProps} />

    {/* Customer */}
    <AppliedRoute path={`/customer`} exact component={Customer} props={childProps} />
    <AppliedRoute path={`/customer/schedule`} exact component={ViewCustomerSchedule} props={childProps} />
    <AppliedRoute path={`/customer/delivery/schedule`} exact component={CustomerDeliverySchedule} props={childProps} />

    {/* Store */}
    <AppliedRoute path={`/store`} exact component={Store} props={childProps} />
    <AppliedRoute path={`/storeroutemapping`} exact component={StoreRouteMapping} props={childProps} />
    <AppliedRoute path={`/storedeliveryschedule`} exact component={StoreDeliverySchedule} props={childProps} />
    <AppliedRoute path={`/viewstoredelivery`} exact component={ViewStoreDelivery} props={childProps} />
    <AppliedRoute path={`/storedeliverystatus`} exact component={StoreDeliveryStatus} props={childProps} />
    <AppliedRoute path={`/store/delivery/sequence/planner`} exact component={DeliverySequencePlanner} props={childProps} />
    <AppliedRoute path={`/storesummary`} exact component={StoreSummary} props={childProps} />
    <AppliedRoute path={`/transactions`} exact component={PaymentTransactions} props={childProps} />
    <AppliedRoute path={`/storedeliverypendingapproval`} exact component={StoreDeliveryPendingApproval} props={childProps} />
    <AppliedRoute path={`/view/invoices`} exact component={Invoice} props={childProps} />
    <AppliedRoute path={`/indent`} exact component={Indent} props={childProps} />
    <AppliedRoute path={`/inactive/stores/delivery`} exact component={InactiveStoresByDeliveryPattern} props={childProps} />
    <AppliedRoute path={`/stores/no/orders`} exact component={StoresWithNoOrders} props={childProps} />
    <AppliedRoute path={`/stores/no/recent/orders/lastfewdays`} exact component={StoresWithNoRecentOrders} props={childProps} />
    <AppliedRoute path={`/stores/outstanding/ledger`} exact component={StoreLedgerReport} props={childProps} />
    <AppliedRoute path={`/stores/earnings`} exact component={StoreEarning} props={childProps} />

    {/* Promotions */}
    <AppliedRoute path={`/promotion`} exact component={Promotion} props={childProps} />

    {/* Reports */}
    <AppliedRoute path={`/report/schedules`} exact component={Schedule} props={childProps} />
    <AppliedRoute path={`/report/summary`} exact component={Summary} props={childProps} />
    <AppliedRoute path={`/report/pendingbottle`} exact component={PendingBottle} props={childProps} />
    <AppliedRoute path={`/report/salesstats`} exact component={SalesStats} props={childProps} />
    <AppliedRoute path={`/report/customertransactions`} exact component={CustomerTransactions} props={childProps} />
    <AppliedRoute path={`/report/salesreport`} exact component={SalesReport} props={childProps} />
    <AppliedRoute path={`/report/agentreport`} exact component={AgentReport} props={childProps} />
    <AppliedRoute path={`/report/storebest2worst`} exact component={StoresB2W} props={childProps} />
    <AppliedRoute path={`/report/storesreport`} exact component={StoresReport} props={childProps} />
    <AppliedRoute path={`/report/store/returns`} exact component={ReturnsReport} props={childProps} />
    <AppliedRoute path={`/report/store/unattended`} exact component={UnAttendedStores} props={childProps} />
    <AppliedRoute path={`/report/store/shelf`} exact component={StoreShelfStats} props={childProps} />
    <AppliedRoute path={`/report/agent/performance/report`} exact component={AgentGraphReport} props={childProps} />
    <AppliedRoute path={`/report/delivery/statewise`} exact component={StateWiseDeliveryReport} props={childProps} />

    {/* Tools */}
    <AppliedRoute path={`/tools/notification`} exact component={Notification} props={childProps} />
    <AppliedRoute path={`/tools/managereasons`} exact component={ManageReason} props={childProps} />
    <AppliedRoute path={`/tools/organisation`} exact component={OrganisationInformation} props={childProps} />
    <AppliedRoute path={`/activity/tracking`} exact component={ActivityTracking} props={childProps} />
    <AppliedRoute path={`/tools/jobs`} exact component={Jobs} props={childProps} />

    {/* Inventory */}
    <AppliedRoute path={`/inventory/master`} exact component={ManageInventoryMaster} props={childProps} />
    <AppliedRoute path={`/inventory/transactions`} exact component={InventoryTransactions} props={childProps} />
    <AppliedRoute path={`/inventory/stock/summary`} exact component={InventoryStockSummary} props={childProps} />
    <AppliedRoute path={`/inventory/daily/report`} exact component={DailyInventoryReport} props={childProps} />
    <AppliedRoute path={`/inventory/stock/report`} exact component={OpeningStockReport} props={childProps} />
    <AppliedRoute path={`/inventory/stock/mismatch/report`} exact component={VerifyPhysicalStockReport} props={childProps} />
    <AppliedRoute path={`/inventory/export/report`} exact component={InventoryReport} props={childProps} />

    {/* Not found */}
    <Route component={NotFound} />
  </Switch>;